import reportService from "@/services/ReportUserService";
import M from "materialize-css";
import General from "@/assets/langpacks/General";
export default {
  name: "ReportAdmin",
  data: () => ({
    ReportData: [],

    ServiceList: [],
    PolicyNumber: "",
    CarNumber: "",
    StartSendDate: null,
    EndSendDate: null,
    StartAppoveDate: null,
    EndAppoveDate: null,
    ServiceID: 0,
    DateTimeOptions: null,
  }),
  components: {},
  mounted() {
    this.DateTimeOptions = {
      format: "yyyy-mm-dd",
      i18n: {
        months: General.Months.geo,
        monthsShort: General.Months.geoShort,
        weekdays: General.WeekDays.geo,
        weekdaysShort: General.WeekDays.geoShort,
        weekdaysAbbrev: General.WeekDays.geoAbbrev,
        cancel: "გაუქმება",
        done: "არჩევა",
      },
    };
    reportService.GetReportInitData().then((res) => {
      
      this.ServiceList = res.limitList;
      this.InitMaterializeComponents();
      this.GetData();
    });
    
  },

  methods: {
    InitMaterializeComponents() {
      this.$nextTick(function () {
        M.FormSelect.init(this.$refs.UserSelect, {});
        M.FormSelect.init(this.$refs.CarWashSelect, {});

        M.Datepicker.init(this.$refs.StartSendDate, this.DateTimeOptions);
        M.Datepicker.init(this.$refs.EndSendDate, this.DateTimeOptions);

        M.Datepicker.init(this.$refs.StartAppoveDate, this.DateTimeOptions);
        M.Datepicker.init(this.$refs.EndAppoveDate, this.DateTimeOptions);
        M.FormSelect.init(this.$refs.ServiceSelect, {});
        M.updateTextFields();
      });
    },
    ClearFilter() {
      this.PolicyNumber = null;
      this.CarNumber = null;
      this.ServiceID = 0;
      this.StartSendDate = null;
      this.EndSendDate = null;
      this.StartAppoveDate = null;
      this.EndAppoveDate = null;
      this.InitMaterializeComponents();
      this.GetData();
    },
    GetData() {
      reportService
        .GetReportData(
          this.ServiceID == 0 ? null : this.ServiceID,
          this.PolicyNumber,
          this.CarNumber,
          this.StartSendDate,
          this.EndSendDate,
          this.StartAppoveDate,
          this.EndAppoveDate
        )
        .then((res) => {
          this.ReportData = res.data;
        });
    },
  },
};
